import React from "react";
import { useNavigate } from "react-router-dom";

export default () => {
  let navigate = useNavigate();

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        Profile
        <div className="modal-action">
          <button className="btn" onClick={() => navigate(-1)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
